import { Injectable, signal, WritableSignal } from '@angular/core';
import { catchError, EMPTY, Observable, take, tap } from 'rxjs';
import { ApiStandardReturn } from '../../models/api-standard-return';
import { SystemParams } from '../../models/system-params';
import { BaseApiService } from '../base-api-service/base-api.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class SystemParamsService extends BaseApiService {
    private readonly resource = '/v1/system-parameters';

    private _darkLogo: WritableSignal<string> = signal('');
    darkLogo = this._darkLogo.asReadonly();

    private _lightLogo: WritableSignal<string> = signal('');
    lightLogo = this._lightLogo.asReadonly();

    private _departmentName: WritableSignal<string> = signal('Department');
    departmentName = this._departmentName.asReadonly();

    private _error: WritableSignal<HttpErrorResponse | null> = signal(null);
    error = this._error.asReadonly();

    constructor() {
        super();
        this.loadSystemParams().subscribe();
    }

    loadSystemParams(): Observable<ApiStandardReturn<SystemParams>> {
        this._error.set(null);

        return this.http.get<ApiStandardReturn<SystemParams>>(this.apiUrl + this.resource).pipe(
            take(1),
            tap(response => {
                if (response.data.lightLogo) {
                    this._lightLogo.set('data:image/png;base64,' + response.data.lightLogo);
                }
                if (response.data.darkLogo) {
                    this._darkLogo.set('data:image/png;base64,' + response.data.darkLogo);
                }
                this._departmentName.set(response.data.name);
                this._error.set(null);
            }),
            catchError((error: HttpErrorResponse) => {
                this._error.set(error);
                return EMPTY;
            }),
        );
    }
}
